import React, { Component } from 'react';
import { createForm } from 'rc-form';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import { Link } from 'react-router-dom';

import Text from 'ui/Text';
import Button from 'ui/Button';
import axios from 'utils/axios';
import localStorage from 'utils/localStorage';
import { AuthSubject } from 'shared/AuthSubject';
import {
  PROFILE_KEY,
  QUESTIONS_KEY,
  STAGE_TYPE_KEY,
  PREVIOUS_STAGE_KEY,
  FLASH_MESSAGE_KEY,
} from 'utils/app-constants';
import { LayoutSubject } from 'shared/LayoutSubject';
import { LanguageSubject } from 'shared/LanguageSubject';
import Auth from 'shared/Auth';

class SignInForm extends Component {
  constructor() {
    super();

    this.state = {
      errorMessage: '',
      loading: false,
      requiredText:
        get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Champs obligatoires' : 'Required',
    };

    this.languageSubjectListener = null;
  }

  componentDidMount() {
    this.languageSubjectListener = LanguageSubject.subscribe(newState => {
      newState;

      this.setState({
        requiredText:
          get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Champs obligatoires' : 'Required',
      });
    });
  }

  componentWillUnmount() {
    if (this.languageSubjectListener !== null) {
      this.languageSubjectListener.unsubscribe();
      this.languageSubjectListener = null;
    }
  }

  signInUser = e => {
    e.preventDefault();

    this.props.form.validateFields((error, values) => {
      if (error) {
        'error', error;
        return;
      }

      this.setState({
        errorMessage: '',
        loading: true,
      });

      const newValues = {
        ...values,
      };

      axios
        .post('/auth/login', newValues)
        .then(response => {
          localStorage.saveList(PROFILE_KEY, response.data);

          const user = Auth.getUser();

          const langMap = {
            en_US: 'en',
            fr_FR: 'fr',
          };

          const userLang = get(user, 'locale');

          axios.get(`/stage/cdr-able`).then(response => {
            let cdrStages = orderBy(get(response.data, 'returned_resultset'), ['ordering']);
            let previousStageId = get(user, 'is_legally_registered')
              ? get(cdrStages[0], 'id', '')
              : get(cdrStages[1], 'id', '');

            let previousQuestions = axios.get(`/stage/${previousStageId}`).then(response => {
              return {
                stage_id: previousStageId,
                questions: get(response.data, 'returned_resultset[0].forms'),
              };
            });

            let currentQuestions = axios
              .get(`/stage/${get(user, 'current_stage_id')}`)
              .then(response => {
                return {
                  stage_id: get(user, 'current_stage_id'),
                  stage_type: get(
                    response.data,
                    'returned_resultset[0].stage_type',
                    ''
                  ).toLocaleLowerCase(),
                  questions: get(response.data, 'returned_resultset[0].forms'),
                };
              });

            Promise.all([previousQuestions, currentQuestions])
              .then(responses => {
                localStorage.saveItem(PREVIOUS_STAGE_KEY, previousStageId);
                this.setState({ cdrMode: true });
                localStorage.saveItem(STAGE_TYPE_KEY, get(responses[1], 'stage_type'));

                localStorage.saveList(QUESTIONS_KEY, get(responses[0], 'questions'));
                localStorage.saveList(
                  get(responses[0], 'stage_id'),
                  get(responses[0], 'questions')
                );
                localStorage.saveList(
                  get(responses[1], 'stage_id'),
                  get(responses[1], 'questions')
                );
                localStorage.removeItem(FLASH_MESSAGE_KEY);

                AuthSubject.next({
                  profile: true,
                  locale: {
                    lang: userLang,
                    local_locale: get(langMap, userLang),
                  },
                });

                LayoutSubject.next({ activeRoute: '/', showHome: false });
              })
              .catch(error => {
                localStorage.removeItem(PROFILE_KEY);

                this.setState({
                  loading: false,
                  errorMessage:
                    get(error, 'response.data.message') ||
                    'Could not proceed. There was an issue retrieveing the questions.',
                });
              });
          });
        })
        .catch(error => {
          this.setState({
            loading: false,
            errorMessage: get(error, 'response.data.message') || error,
          });
        });
    });
  };

  render() {
    const { getFieldDecorator, getFieldError } = this.props.form;

    return (
      <form onSubmit={this.signInUser} className="signup-form signin-form">
        <div className={this.state.loading ? 'text-center waiting' : 'hidden'}>
          <Text>Submitting Info ...</Text>
        </div>
        <div className={this.state.errorMessage ? 'alert' : 'hidden'}>
          <Text type="explanation" modifiers="normal__smaller">
            {`${this.state.errorMessage}`}
          </Text>
        </div>
        <div className="signup-form__field">
          <label htmlFor="email">
            <FormattedMessage id="Form.EmailAddress" defaultMessage="Email" />
          </label>
          {getFieldDecorator('email', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: `${this.state.requiredText}`,
              },
            ],
          })(<input type="email" className="signup-form__form-control" />)}
          <div className={getFieldError('email') ? 'error' : 'hidden'}>
            {(getFieldError('email') || []).join(', ')}
          </div>
        </div>
        <div className="signup-form__field">
          <div className="flex justify-content-between">
            <label htmlFor="password">
              <FormattedMessage id="Form.Password" defaultMessage="Password" />
            </label>
            <Link to="/reset-password" className="primary-orange form-link">
              <Text type="small">
                <FormattedMessage id="Form.ForgotPassword" defaultMessage="Forgot Password?" />
              </Text>
            </Link>
          </div>
          {getFieldDecorator('password', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: `${this.state.requiredText}`,
              },
            ],
          })(<input type="password" className="signup-form__form-control" />)}
          <div className={getFieldError('password') ? 'error' : 'hidden'}>
            {(getFieldError('password') || []).join(', ')}
          </div>
        </div>
        <div className="flex justify-content-between">
          <Button type="submit" nature="primary">
            <FormattedMessage id="Login" defaultMessage="Login" />
          </Button>
          <Link to="/apply-now" className="btn btn-secondary" style={{ borderRadius: '0.3em' }}>
            <Text type="small">
              <FormattedMessage id="SignUp" defaultMessage="SignUp" />
            </Text>
          </Link>
        </div>
      </form>
    );
  }
}

const WrappedSignInForm = createForm()(SignInForm);

export default WrappedSignInForm;



// WEBPACK FOOTER //
// ./src/components/HomePage/SignInForm.js